<div class="combo-box">
  <mat-form-field appearance="outline" hideRequiredMarker="true">
    <mat-label>Attribute</mat-label>
    <mat-select
      [hideSingleSelectionIndicator]="true"
      [value]="selectedStyleOption"
      (valueChange)="onStyleChanged($event)"
      >
      @for (option of dataSource; track option) {
        <mat-option [value]="option.value">
          {{ option.display }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
